<div class="modal-header">
    <h4 class="modal-title d-flex justify-content-between">
        {{ 'variable-alarms_select-template-header' | translate }}
        <app-tooltip
            [popover]="'variable-alarms_Select-variable-alarm-template-info' | translate" />
    </h4>
</div>
<div class="modal-body">
    @if (variableAlarmTemplates$ | async; as variableAlarmTemplates) {
        <div class="row">
            @if (variableAlarmTemplates.loading) {
                <app-load></app-load>
            } @else {
                @for (variableAlarmTemplate of variableAlarmTemplates.value; track $index) {
                    <div class="col-sm-12 col-md-6 col-lg-4">
                        <div class="card mb-3" style="min-height: 180px">
                            <div
                                class="card-title d-flex justify-content-between align-items-center me-0 p-3 pb-0">
                                <b class="mb-0">{{ variableAlarmTemplate.translation.header }}</b>
                                <i
                                    popoverClass="custom-popover"
                                    [ngbPopover]="variableAlarmTemplate.translation.description"
                                    class="bi bi-info-circle align-self-start"
                                    style="cursor: pointer">
                                </i>
                            </div>
                            <div class="card-body py-0">
                                <p class="mb-0">
                                    {{
                                        variableAlarmTemplate.translation.description.length > 100
                                            ? variableAlarmTemplate.translation.description
                                                  .substring(0, 100)
                                                  .trim() + '...'
                                            : variableAlarmTemplate.translation.description
                                    }}
                                </p>
                            </div>
                            <div class="text-end me-1 mb-1">
                                <button
                                    class="btn btn-link"
                                    type="button"
                                    (click)="selectTemplate(variableAlarmTemplate)">
                                    {{ 'common_Select' | translate }}
                                </button>
                            </div>
                        </div>
                    </div>
                } @empty {
                    <div class="text-center w-100 alert alert-warning">
                        {{ 'utilities_NO_METER_OR_SENSORS_SUPPORTED' | translate }}
                    </div>
                }
            }
        </div>
    }
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-outline-primary" (click)="activeModal.close()">
        {{ 'common_cancel_button' | translate }}
    </button>
</div>
